// import React, { useState } from 'react';

// const Tooltip = ({ children, text }) => {
//   const [show, setShow] = useState(false);

//   return (
//     <div
//       onMouseEnter={() => setShow(true)}
//       onMouseLeave={() => setShow(false)}
//       style={{ position: 'relative', display: 'inline-block' }}
//     >
//       {children}
//       {show && (
//         <div
//           style={{
//             position: 'absolute',
//             bottom: '100%',
//             left: '50%',
//             transform: 'translateX(-50%)',
//             backgroundColor: '#61B9E8',
//             color: 'white',
//             padding: '5px',
//             borderRadius: '5px',
//             whiteSpace: 'nowrap',
//             zIndex: 1,
//           }}
//         >
//           {text}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Tooltip;

import React, { useState } from 'react';

const tooltipVariants = {
  default: {
    backgroundColor: '#61B9E8',
    color: 'white',
  },
  secondary: {
    backgroundColor: 'white',
    color: '#120F31',
  },
};

const Tooltip = ({ children, text, variant = 'default' }) => {
  const [show, setShow] = useState(false);

  const styles = tooltipVariants[variant] || tooltipVariants['default'];

  return (
    <div
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      {children}
      {show && (
        <div
          style={{
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: styles.backgroundColor,
            color: styles.color,
            padding: '5px',
            borderRadius: '5px',
            whiteSpace: 'nowrap',
            zIndex: 1,
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
